export function saveObjArr(hash, bucketName, objectName, uploadId, chunk) {
    const date = new Date().getTime();
    const res = { date: date, bucketName, objectName, uploadId, chunk };
    localStorage.setItem(hash, JSON.stringify(res));
}
export function getObjArr(name) {
    const res = window.localStorage.getItem(`chunk${name}`);
    if (res && res !== 'undefined') {
        return JSON.parse(res);
    }
    return false;
}
export function clearLocalStorage(name) {
    localStorage.removeItem(`chunk${name}`);
}
